import React from 'react';

import { Card, Tabs, TabsProps, Timeline } from 'antd';
// import Tests from "../../model/Tests";
import Command from '../../model/Command';
import Test from '../../model/Test';

import { AutoSizer, List as VList } from 'react-virtualized';
import CommandView, { CommandViewHeader } from './CommandView';

import './TestsView.css';

import { Booking, BookingConstraints } from '../../model/Booking';
// import RestrictionsView from '../Views/RestrictionsView';
import DetailsView from '../Views/DetailsView';
import MediaQuery from 'react-responsive';
import { isNullOrUndefined } from '../../utils';
import { useTranslation } from '@nic-react-i18n/core';
import dayjs from 'dayjs';

interface TestInfoProps {

    created: dayjs.Dayjs;
    status?: string;
}

interface TestsProps {
    tests?: Array<Test>;
}
interface CommandsProps {
    commands?: Array<Command>;
}

interface RestrinctionsProps {
    booking: Booking;
    restrictions?: BookingConstraints;
}

type TestsViewProps = TestInfoProps & TestsProps & CommandsProps & RestrinctionsProps

// const TimelineItem = Timeline.Item;
const color: Record<string,string> = {
    succeeded: 'green',
    failed: 'red'
};


type CommandType = {index: number, key: string, style: object};
type AutoSizeType = {width: number};

interface NoCommandsInterface {
    expired: boolean;
}

type NoCommandsProps = NoCommandsInterface

const NoCommands: React.FC<NoCommandsProps> = (props: NoCommandsProps) => {
    const {expired} = props;
    const {t} = useTranslation()
    let msg = (expired ? t('tests.noCommands') : t('tests.pending'));
    let icon = (expired ? <i className={'fal fa-ban'} /> : <i className={'fal fa-hourglass'} />);
    return (
      <div
          style={{
              display: 'flex',
              flexDirection: 'column',
              paddingTop: '30px',
              justifyContent: 'center',
              alignItems: 'center'
          }}
      >
          <span
              style={{
                  color: 'orange',
                  fontSize: '2rem',
              }}
          >
              {icon}
          </span>
          <span
              style={{
                  color: 'orange',
                  fontSize: '1.1rem',
              }}
          >
              {msg}
          </span>
      </div>
    );
};

interface TestViewHeaderInterface {
    testDate: dayjs.Dayjs
}

type TestViewHeaderProps = TestViewHeaderInterface

const TestViewHeader: React.FC<TestViewHeaderProps> = (props) => {
    const {testDate} = props;
    const {locale} = useTranslation()

    //console.log('Created: ', testDate)
    const timezone =
        new Intl.DateTimeFormat('it-IT', {hour: '2-digit', minute: '2-digit', timeZoneName: "short"})
    return (
        <div
            style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'center',
                alignItems: 'center',
                textTransform: 'capitalize',
                fontWeight: 700,
                fontSize: 'larger',
            }}
        >

            <div
                style={{
                    paddingRight: '20px'
                }}
            >
                <span className="fa-layers fa-fw" style={{fontSize: '16pt', color: 'lightgray'}}>
                    <i className="fal fa-calendar"/>
                    <span
                        className="fa-layers-text"
                        data-fa-transform="shrink-6 down-2"
                        style={{color: 'gray'}}
                    >
                        {testDate.date()}
                    </span>
                </span>

                <span className={'range-day'}>
                    {new Intl.DateTimeFormat(locale, {
                        year: "numeric",
                        month: "long"}).format(testDate.toDate())}

                </span>
            </div>
            <div>
                <span style={{paddingRight: '5px',  color: 'lightgray'}}>
                    <i className={'fal fa-clock'}/>
                </span>
                <span>
                    {timezone.format(testDate.toDate())}
                </span>
            </div>
        </div>
    );
};

const TestsView: React.FC<TestsViewProps> = (props) => {
    const {t} = useTranslation()

    const renderCommand = ({index, key, style}: CommandType) => {
        const {commands} = props;
        let component = <div key={key} style={style} />;
        if (!isNullOrUndefined(commands)) {
            const command = (commands as any)[index];
            component = <CommandView key={key} style={style} command={command}/>;
        }
        return (
            <div key={key}>
                {component}
            </div>
        );
    }

    const commandComponent = (hasCommands: boolean, commandNum: number, isExpired: boolean, size: string) => {
        if (hasCommands) {
            var height = window.innerHeight;
            return (
                <AutoSizer disableHeight={true}>
                    {({width}: AutoSizeType) => (
                        <div>
                            <CommandViewHeader width={width}  size={size}/>
                            < VList
                                className={'vlist'}
                                style={{paddingLeft: '20px', paddingTop: '20px'}}
                                autoHeight={false}
                                rowHeight={40}
                                height={height / 2}
                                width={width}
                                rowRenderer={renderCommand}
                                rowCount={commandNum}
                            />
                        </div>
                    )}
                </AutoSizer>
            );
        } else {
            return (
                <NoCommands expired={isExpired}/>
            );
        }
    }


    const {tests, commands, created, restrictions, booking} = props;
        let testsComponent: any[] = []
        let commandsComponent: any[] = []
        let hasCommands = (commands ? commands.length > 0: false);
        // let hasConstraints = (!isNullOrUndefined(restrictions));
        let hasTests = (!isNullOrUndefined(tests));
        let isExpired = dayjs().isAfter(dayjs(created));
        let sequenceMap =  {};
        let i = 0;
        if (!isNullOrUndefined(commands)) {
            commands && commands.forEach((command) => {
                if (command.sequence) {
                    (sequenceMap as any)[command.sequence] = command;
                }
                commandsComponent.push(
                    <Timeline.Item
                        key={i++}
                        color={(command.sequence ? 'green' : 'red')}
                        dot={(!command.sequence) ? <i className={'anticon fas fa-exclamation-circle'}/> : ''}
                    >
                        {command.request.commandType}
                    </Timeline.Item>
                );
            });
        }
        if (!isNullOrUndefined(tests)) {
            tests && tests.forEach((test, testNum) => {
                let items: any[] = []

                if (test.commandsSequenceId) {
                    test.commandsSequenceId.forEach((id) => {
                        const {request} = (sequenceMap as any)[id];
                        items.push(<li key={id}>{request.commandType}</li>);
                    });
                }
                testsComponent.push({
                    key: testNum,
                    color: color[test.status],
                    children: (
                        <>
                            <div>{`Test ${testNum + 1}: ${test.name}`}</div>
                            <div>
                                <ul>{items}</ul>
                            </div>
                        </>
                    )
                })
            })
        }
       // var width = window.innerWidth * 80 / 100;
        //  var height = window.innerHeight;
        // let createdHour = moment(created).subtract(1, 'hour');
        let createdHour = dayjs(created);
        let tabPane = 0;
        let commandNum =  (commands?.length ?? 0);
        const tabItems: TabsProps['items'] = []
        tabItems.push({
            key: `${++tabPane}`,
            label: t('tests.testDetails'),
            children: (
            <div style={{marginTop: '20px'}}>
                <DetailsView booking={booking} restrictions={restrictions}/>
            </div>
        )
        })
        if (hasTests) {
            tabItems.push({
                key:`${++tabPane}`,
                label: t('tests.testlist'),
                children: (
                        <div style={{marginLeft: '20px', marginTop: '20px'}}>
                            <Timeline items={testsComponent}/>
                        </div>
                    )
            })
        }
    tabItems.push({
        key:`${++tabPane}`,
        label: t('tests.testcommands'),
        children: (
            <div style={{marginLeft: '30px', marginTop: '20px'}}>
                <MediaQuery minWidth={1200}>
                    {
                        commandComponent(hasCommands, commandNum, isExpired, 'large')
                    }
                </MediaQuery>
                <MediaQuery minWidth={600} maxWidth={1199}>
                    {
                        commandComponent(hasCommands, commandNum, isExpired, 'medium')
                    }
                </MediaQuery>
                <MediaQuery minWidth={300} maxWidth={599}>
                    {
                        commandComponent(hasCommands, commandNum, isExpired, 'small')
                    }
                </MediaQuery>
            </div>
            )
    })

    return (
        <div style={{width: '100%'}}>
            <Card styles={{body: {paddingTop: '10px'}}}>
                {createdHour &&
                    <TestViewHeader testDate={createdHour}/>
                }
                <Tabs defaultActiveKey="1" items={tabItems}/>
            </Card>
            </div>
        );

}
export default TestsView